import _ from "lodash"
import { Store } from "utilities/Redux/store"

export const getChatById = (state: Store, id: string) =>
  state.chats[id] ? state.chats[id] : undefined

export const getChats = (state: Store) => state.chats
